module.exports = __webpack_public_path__ + "static/media/PseudoFeelingsList.cc438000.csv";